import React from 'react'
import styled from 'styled-components'
import { DocumentationDataTable } from '../Components/Documentation/DocumentationDataTable'
import { DocumentationFirst } from '../Components/Documentation/DocumentationFirst'
import { colors } from '../Shared/colors'

export const DocumentationComponent = () => {
  return (
    <Main>
        <DocumentationFirst/>
        <DocumentationDataTable/>
    </Main>
  )
}


const Main = styled.div`
background-color: ${colors.inputWhite};
min-height: calc(100vh - 10vh);
margin-top: 10vh;
display: flex;
padding-top: 2em;
flex-direction: column;
justify-content: center;
align-items: center;
`